module.exports = "/images/plan-medium-icon.svg?17f499434656383c644792f014dfc78f";